import React from "react";

function NewPage(props) {
  return (<div> 
				<iframe
					style={{width: 100+'%', height: 90+'vh'}}
		            src="https://gingerkowal.users.earthengine.app/view/rpmgobisteppe">
            	</iframe>
  		  </div>);
}

export default NewPage;